import React from "react";
import "./SetupDeleteModal.scss";
import { Button } from "../CommonUIComponents/Button/Button";
import { WarningIcon } from "../../icons";
import {
  setupRemoveUserModalHeader,
  setupRemoveUserModalBody,
  DeleteBtn,
  CancelBtn
} from "../../util/constants";
import { Modal } from "../CommonUIComponents/Modal/Modal";

export function UserDeleteModal({ isModalVisible, onClose, onConfirm }) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      body={<span className="body-content">{setupRemoveUserModalBody}</span>}
      header={
        <div className="file-version-history-modal-header">
          <div className="motif-fab">
            <WarningIcon />
          </div>
          <span>{setupRemoveUserModalHeader}</span>
        </div>
      }
      footer={
        <div className="view-endagement-delete-modal-footer">
          <Button variant="secondary" onClick={onClose}>
            {CancelBtn}
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {DeleteBtn}
          </Button>
        </div>
      }
    />
  );
}
